(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("element-ui"), require("cb-components-common"), require("cb-components-suitability"));
	else if(typeof define === 'function' && define.amd)
		define("cb-components-morningstar-award", ["element-ui", "cb-components-common", "cb-components-suitability"], factory);
	else if(typeof exports === 'object')
		exports["cb-components-morningstar-award"] = factory(require("element-ui"), require("cb-components-common"), require("cb-components-suitability"));
	else
		root["cb-components-morningstar-award"] = factory(root["ELEMENT"], root["cb-components-common"], root["cb-components-suitability"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_element_ui__, __WEBPACK_EXTERNAL_MODULE_cb_components_common__, __WEBPACK_EXTERNAL_MODULE_cb_components_suitability__) {
return 